<template>
	<input
		v-model="innerValue"
		class="base-input"
	>
</template>

<script>
export default {
	name: 'BaseInput',
	inheritAttrs: true,
	props: {
		value: {
			type: [Number, String],
			default: () => '',
		},
	},
	data() {
		return {
			innerValue: this.value,
		};
	},
	watch: {
		value(value) {
			this.innerValue = value;
		},
		innerValue(innerValue) {
			this.$emit('input', this.value.constructor(innerValue));
		},
	},
	created() {
		this.innerValue = this.value;
	},
};
</script>

<style lang="stylus" scoped>
@require '../colors'

.base-input
	box-sizing border-box
	border 0
	height 100%
	background-color base-background-color
	color base-text-color
</style>



// WEBPACK FOOTER //
// src/components/BaseInput.vue